import { Entypo, MaterialIcons } from '@native-base/icons';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { Icon } from 'native-base';
import React from 'react';

import TabBar from './TabBar';
import Home from '../Home';
import Payments from '../Payments';

const Tab = createBottomTabNavigator();

function TopLevel() {
  return (
    <Tab.Navigator
      initialRouteName="Home"
      screenOptions={{
        header: () => null,
        unmountOnBlur: true,
      }}
      // eslint-disable-next-line react/no-unstable-nested-components
      tabBar={(props) => <TabBar {...props} />}
    >
      <Tab.Screen
        name="Home"
        component={Home}
        options={{
          tabBarLabel: 'Portefeuille',
          // eslint-disable-next-line react/no-unstable-nested-components
          tabBarIcon: () => <Icon as={Entypo} name="wallet" />,
        }}
      />
      <Tab.Screen
        name="Payments"
        component={Payments}
        options={{
          tabBarLabel: 'Paiements',
          // eslint-disable-next-line react/no-unstable-nested-components
          tabBarIcon: () => <Icon as={MaterialIcons} name="payment" />,
        }}
      />
    </Tab.Navigator>
  );
}

export default TopLevel;
